import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { HOST } from "../data/content";

const CTA_STATS = [
  { value: HOST.rating, label: "Guest rating" },
  { value: HOST.reviewsTotal, label: "Reviews" },
  { value: "3", label: "City homes" },
];

export const CTA = () => (
  <section data-testid="primary-cta-section" className="px-6 pb-24 md:pb-36 lg:px-10">
    <Reveal>
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#C4623C] px-8 py-20 text-center md:px-16 md:py-28">
        <div
          aria-hidden="true"
          className="absolute -top-32 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-[#E3A387]/40 blur-3xl"
        />
        <p className="font-mono-accent relative text-[11px] uppercase tracking-[0.28em] text-[#FBF8F3]/80">
          Bookings open on Airbnb
        </p>
        <h2 className="font-serif-display relative mx-auto mt-6 max-w-3xl text-4xl leading-[1.02] tracking-tight text-[#FBF8F3] sm:text-6xl lg:text-7xl">
          Come stay a while.
        </h2>
        <p className="relative mx-auto mt-6 max-w-md text-base leading-relaxed text-[#FBF8F3]/85">
          Check live availability, browse every photo and book directly through our
          verified Airbnb host profile.
        </p>
        <div className="relative mt-10">
          <a
            href={HOST.airbnbProfile}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="airbnb-profile-cta-button"
            className="group inline-flex items-center gap-2.5 rounded-full bg-[#FBF8F3] px-9 py-4.5 text-sm font-semibold text-[#201B17] transition-colors duration-300 hover:bg-[#201B17] hover:text-[#FBF8F3]"
          >
            View our Airbnb profile
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
        <div className="relative mx-auto mt-14 flex max-w-lg items-center justify-between divide-x divide-[#FBF8F3]/25">
          {CTA_STATS.map((stat) => (
            <div key={stat.label} className="flex-1 px-4" data-testid={`cta-stat-${stat.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <p className="font-serif-display text-3xl text-[#FBF8F3] md:text-4xl">{stat.value}</p>
              <p className="font-mono-accent mt-1.5 text-[10px] uppercase tracking-[0.18em] text-[#FBF8F3]/70">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  </section>
);
